<template>
  <div class="page-container md-layout-column">
    <div v-if="!splash">
      <md-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="showNavigation = true">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title">{{ title }}</span>
        <md-icon class="app-icon md-size-2x">
          <img src="@/assets/icons/app.svg" alt="app">
        </md-icon>
      </md-toolbar>

      <md-drawer :md-active.sync="showNavigation">
        <md-toolbar class="md-primary" md-elevation="0">
          <span class="md-title">ZANA</span>
        </md-toolbar>

        <md-list>
          <md-list-item @click="goTo('/')">
            <md-icon>
              <img src="@/assets/icons/list.svg" alt="list">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.listPlot') }}</span>
          </md-list-item>

          <md-list-item @click="goTo(firstStep)">
            <md-icon>
              <img src="@/assets/icons/add.svg" alt="add">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.addPlot') }}</span>
          </md-list-item>

          <md-list-item @click="goTo('/area')">
            <md-icon>
              <img src="@/assets/icons/map_grey.svg" alt="map">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.tiles') }}</span>
          </md-list-item>

          <md-divider class="md-inset"></md-divider>

          <md-list-item @click="download()">
            <md-icon>
              <img src="@/assets/icons/sync.svg" alt="sync">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.download') }}</span>
          </md-list-item>

          <md-list-item @click="uploadJson()">
            <md-icon>
              <img src="@/assets/icons/upload.svg" alt="upload">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.upload') }}</span>
          </md-list-item>

          <md-divider class="md-inset"></md-divider>

          <md-list-item @click="goTo('/settings')">
            <md-icon>
              <img src="@/assets/icons/settings.svg" alt="settings">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.settings') }}</span>
          </md-list-item>

          <!-- <md-list-item>
            <md-icon>
              <img src="@/assets/icons/credits.svg">
            </md-icon>
            <span class="md-list-item-text">{{ $t('home.credits') }}</span>
          </md-list-item> -->
        </md-list>
      </md-drawer>

      <md-content>
        <router-view :measurements="measurements" @title="getTitle" :update="update" />

        <md-snackbar md-position="center" :md-duration="Infinity" :md-active.sync="showSnackbar" md-persistent>
          <span>{{ $t("global.updateAvailable") }}</span>
          <md-button class="md-primary" @click="updateApp()">{{ $t("global.update") }}</md-button>
        </md-snackbar>
      </md-content>
    </div>

    <md-dialog
        :md-active.sync="upDialog"
        :md-fullscreen="false"
        :md-click-outside-to-close="false"
        :md-close-on-esc="false">
      <md-dialog-title v-show="done">{{ upMsg }}</md-dialog-title>
      <md-dialog-title v-show="!done">
        <spinner :load="!done" />
      </md-dialog-title>
      <md-dialog-actions>
        <md-button class="md-primary" @click="closeUpDialog()" v-if="done">Ok</md-button>
        <md-button class="md-primary" @click="upDialog = false" v-else>{{ $t('global.cancel') }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <splash-screen @splash="removeSplash" v-if="splash" />

    <input type="file" ref="dbUpload" style="display:none" @change="handleFile()" />
  </div>
</template>

<script>
import SplashScreen from '@/components/SplashScreen'
import Spinner from '@/components/Spinner'

import exportDb from '@/assets/scripts/exportDb'
import importDb from '@/assets/scripts/importDb'
import clearState from '@/assets/scripts/clearState'
import { setDomains } from '@/assets/scripts/domainsManager'

import localForage from 'localforage'
import { Workbox } from 'workbox-window'

const wb = new Workbox('/service-worker.js')

export default {
  components: {
    SplashScreen,
    Spinner
  },
  data: () => ({
    showNavigation: false,
    tmp: null,
    edit: null,
    measurements: null,
    title: '',
    splash: true,
    upDialog: false,
    upMsg: '',
    update: false,
    done: false,
    showSnackbar: false,
    firstStep: '/team'
  }),
  mounted () {
    this.checkForUpdate()
    setDomains() // set up domains
    this.title = 'List Plot'

    this.measurements = localForage.createInstance({
      driver: localForage.INDEXEDDB,
      name: 'arcadiaDb',
      storeName: 'measurements'
    })
  },
  methods: {
    goTo: function (path) {
      if (path === this.firstStep) {
        clearState()
      }
      this.showNavigation = false
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
    },

    getTitle: function (value) {
      this.title = value
    },

    removeSplash: function () {
      this.splash = false
    },

    download: function () {
      this.upDialog = true
      exportDb(this.measurements).then(() => {
        this.upMsg = this.$i18n.t('home.downMsgSuc')
        this.done = true
      }).catch(error => {
        this.upMsg = this.$i18n.t('home.downMsgErr')
        this.done = true
        console.log(error)
      })
    },

    uploadJson: function () {
      this.$refs.dbUpload.click()
      this.upDialog = true
    },

    handleFile: function () {
      let file = this.$refs.dbUpload.files[0]
      if (file.type === 'application/json') {
        let reader = new FileReader()
        reader.onload = event => {
          importDb(this.measurements, JSON.parse(event.target.result)).then(() => {
            this.uploadEnded(this.$i18n.t('home.upMsgSuc'))
          }).catch(error => {
            this.uploadEnded(this.$i18n.t('home.upMsgErr'))
            console.log(error)
          })
        }
        reader.readAsText(file)
      } else {
        this.uploadEnded(this.$i18n.t('home.upMsgErr'))
      }
    },

    uploadEnded: function (msg) {
      this.upMsg = msg
      this.done = true
      this.$refs.dbUpload.value = ''
    },

    closeUpDialog: function () {
      this.upDialog = false
      this.done = false
      if (this.upMsg === this.$i18n.t('home.upMsgSuc')) {
        this.update = !this.update
        this.showNavigation = false
      }
    },

    checkForUpdate: function () {
      wb.addEventListener('waiting', (event) => {
        this.showSnackbar = true
      })
      wb.register()
    },

    updateApp: function () {
      wb.addEventListener('controlling', (event) => {
        this.showSnackbar = false
        window.location.reload()
      })
      wb.messageSW({ type: 'SKIP_WAITING' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .app-icon {
    margin-right: 8px;
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .md-drawer {
    max-width: calc(100vw - 125px);
  }

  .md-content {
    padding: 16px;
    background-color: transparent;
  }

  footer {
    margin-bottom: 10px;
  }
</style>
